import React, { useCallback, useMemo, useState } from "react";
import { IonActionSheet, IonLoading, useIonToast } from "@ionic/react";
import { useGetShippingZonesQuery } from "../../providers/shippingAndPayment";
import { useConfig } from "../../providers/config";
import "./ShippingZonesModalWidget.scss";
import { useTranslation } from "react-i18next";

interface ActionSheetButton<T = any> {
  text?: string;
  role?: "cancel" | "destructive" | "selected" | string;
  icon?: string;
  cssClass?: string | string[];
  id?: string;
  htmlAttributes?: { [key: string]: any };
  handler?: () => boolean | void | Promise<boolean | void>;
  data?: T;
}

interface ShippingZonesModalWidgetProps {
  setIsModalOpened: (state: boolean) => void;
}

const ShippingZonesModalWidget = ({ setIsModalOpened }: ShippingZonesModalWidgetProps) => {
  const { t } = useTranslation();
  const [presentToast] = useIonToast();
  const [showLoading, setShowLoading] = useState(true);

  const config = useConfig();
  const presentErrorToast = useCallback(() => {
    presentToast({
      message: t("unexpectedErrorShippingZones"),
      duration: 2000,
      color: "danger",
    });
  }, [presentToast, t]);

  const { data: shippingZones } = useGetShippingZonesQuery({
    onError: presentErrorToast,
    enabled: config?.shipping.isShippingZonesEnabled && config?.shipping.showDefaultShippingZone,
  });

  const actionButtons = useMemo(() => {
    if (shippingZones) {
      return shippingZones.map((zone): ActionSheetButton => {
        return {
          text: zone.name,
          id: zone.id,
          handler: () => {},
        };
      });
    }

    return [];
  }, [shippingZones]);

  return (
    <>
      <IonLoading isOpen={showLoading} message={t("Please wait...")} />

      {!!actionButtons?.length && (
        <IonActionSheet
          onWillDismiss={() => {
            setIsModalOpened(false);
          }}
          onDidPresent={() => {
            setShowLoading(false);
          }}
          backdropDismiss={false}
          keyboardClose={false}
          mode="ios"
          cssClass={"shipping-zones-action-sheet"}
          isOpen={true}
          header={t("Select shipping zone")}
          buttons={actionButtons}
        ></IonActionSheet>
      )}
    </>
  );
};

const ShippingZonesWrapper = (props: ShippingZonesModalWidgetProps) => {
  return <ShippingZonesModalWidget {...props} />;
};

export { ShippingZonesWrapper as ShippingZonesModalWidget };
